export const WIDGET_THEME_MESSAGE_TYPE = 'bilyoner:widget-theme';

export const postThemeToWidgetIframe = (iframe, theme) => {
  if (!iframe || !iframe.contentWindow || !theme) return;
  iframe.contentWindow.postMessage({
    type: WIDGET_THEME_MESSAGE_TYPE,
    theme,
  }, '*');
};
